// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loupe_eye-dropper_qsEfW {\n    position: absolute;\n    border-radius: 100%;\n    border: 1px solid #222;\n}\n", "",{"version":3,"sources":["webpack://./src/components/loupe/loupe.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;AAC1B","sourcesContent":[".eye-dropper {\n    position: absolute;\n    border-radius: 100%;\n    border: 1px solid #222;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"eye-dropper": "loupe_eye-dropper_qsEfW",
	"eyeDropper": "loupe_eye-dropper_qsEfW"
};
module.exports = ___CSS_LOADER_EXPORT___;
